import Index from "./pages/Index";
import "./styles.css";
import { BrowserRouter, Router, Routes, Route, Navigate } from "react-router-dom";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" Component={Index}/>
      </Routes>
    </BrowserRouter>
  );
}